@if (section() === 'totals') {
  <!-- Checkout Recap -->
  <div class="mb-6">
    <div class="bg-gray-200 mb-6 md:mb-8 px-4 py-3 rounded-lg">
      <h4 class="font-bold">
        Total amount due:
        <span data-cy="checkout-recap-total-amount-due">
          ${{
            transaction.transaction.tdcTransaction?.balance | number: '1.2-2'
          }}
        </span>
      </h4>
    </div>
    <div class="mb-4 w-full">
      <div
        class="flex justify-between items-center bg-main-off-white mb-2 px-3 py-2 rounded-lg text-xs">
        <p>Seats</p>
        <p class="font-bold text-main">
          ${{ displayTotalPriceSeats | number: '1.2-2' }}
        </p>
      </div>
    </div>

    @if (
      hasActiveDiscount && totalDiscount !== null && isDiscountCodesEnabled()
    ) {
      <div class="mb-4 w-full">
        <div
          data-cy="checkout-recap-discount"
          class="flex justify-between items-center bg-red-50 mb-2 px-3 py-2 rounded-lg text-xs">
          <p class="text-red-600">Discount ({{ discountCode }})</p>
          <p class="font-bold text-red-600">
            − ${{ totalDiscount | number: '1.2-2' }}
          </p>
        </div>
      </div>
    }

    @if (isTicketFeeEnabled()) {
      @for (serviceCharge of serviceChargesDetails; track $index) {
        @if (serviceCharge.amount) {
          <div class="mb-4 w-full">
            <div
              class="flex justify-between items-center bg-main-off-white mb-2 px-3 py-2 rounded-lg text-xs">
              <p>{{ serviceCharge.name }}</p>
              <p class="font-bold text-main">
                ${{ serviceCharge.amount | number: '1.2-2' }}
              </p>
            </div>
          </div>
        }
      }
    } @else {
      @if (transaction.transaction.tdcTransaction?.serviceCharges) {
        <div class="mb-4 w-full">
          <div
            class="flex justify-between items-center bg-main-off-white mb-2 px-3 py-2 rounded-lg text-xs">
            <p>Total ticket fees</p>
            <p class="font-bold text-main">
              ${{
                transaction.transaction.tdcTransaction?.serviceCharges
                  | number: '1.2-2'
              }}
            </p>
          </div>
        </div>
      }
    }

    @if (transaction.transaction.tdcTransaction?.hasInsuranceRainout) {
      <div class="mb-4 w-full">
        <div
          class="flex justify-between items-center bg-main-off-white mb-2 px-3 py-2 rounded-lg text-xs">
          <p>Rainout insurance</p>
          <p class="font-bold text-main">
            ${{
              transaction.transaction.tdcTransaction?.insuranceRainoutPrice
                | number: '1.2-2'
            }}
          </p>
        </div>
      </div>
    }
  </div>
}

@if (section() === 'legal') {
  <!-- Terms & Conditions -->
  <div class="mb-4 md:mb-2">
    <!--
      Checkbox + label + legal text as a two-column row (`items-start` + `gap-2`), with the
      label and `app-legal-terms` wrapped in one column div so both share the same
      left edge (right after the checkbox + gap). If they are separate rows instead,
      the label starts at `ml-2` from the checkbox while the legal text
      (a sibling of that row) starts flush at the row's own left edge, and the
      "I agree to the following" text and the legal text under it stop lining up.
    -->
    <div class="flex items-start gap-2 mb-1">
      <!--
        This control renders as a 16px empty
        circle (a radio), not a square checkbox — `.terms-radio` restyles it.
        Kept as `type="checkbox"` on purpose: a real radio cannot be
        un-checked, and the patron must be able to withdraw consent.
        `mt-0.5`: with `items-start` (needed so the checkbox pins to the top of the column instead
        of centering against its now much taller label+legal-text content), the 16px box otherwise
        sits a couple px above the label's own text baseline area — this nudges it back down to
        align with the first line of "I agree to the following".
      -->
      <input
        type="checkbox"
        class="mt-0.5 terms-radio"
        placeholder=""
        id="marketing"
        name="marketing"
        [value]="true"
        [(ngModel)]="paymentDetails.acceptedTerms" />
      <div>
        <label for="marketing" class="font-bold text-black text-sm"
          >I agree to the following
          <span class="text-red align-middle" aria-hidden="true">*</span></label
        >
        <!-- The legal-text type now lives in `app-legal-terms` itself — no wrapper needed. -->
        <app-legal-terms
          [legalTextData]="this.configurationService.configuration.legalText" />
      </div>
    </div>
    <!-- Extra Checkbox if exist in cfg client -->
    @if (
      configurationService.configuration.extraCheckbox &&
      configurationService.configuration.extraCheckbox.active
    ) {
      <div class="mt-2 mb-4 md:mb-2">
        <!-- Same two-column layout as the terms block above, for the same reason. -->
        <div class="flex items-start gap-2 mb-1">
          <!-- Same radio-styled checkbox as the terms control above. -->
          <input
            type="checkbox"
            class="mt-0.5 terms-radio"
            placeholder=""
            id="extra-checkbox"
            name="extra-checkbox"
            [value]="true"
            [(ngModel)]="paymentDetails.extraCheckbox" />
          <div>
            <!-- Same "I agree" styling as the terms checkbox above. -->
            <label for="extra-checkbox" class="font-bold text-black text-sm"
              >I agree to the following
              @if (configurationService.configuration.extraCheckbox.required) {
                <span class="text-red align-middle" aria-hidden="true">*</span>
              }
            </label>
            <!-- Same legal-text styling as the terms block above, full content, no scroll. -->
            <div
              class="font-medium text-[#7b7b7b] text-xs leading-4"
              [innerHTML]="
                configurationService.configuration.extraCheckbox.text
              "></div>
          </div>
        </div>
      </div>
    }
  </div>
}
